/**
 * Proxies CMS video URLs through the Next.js API to avoid CORS and tracking protection issues.
 */
export function proxyCmsVideo(videoUrl: string | undefined | null): string {
  if (!videoUrl) {
    return ''
  }

  if (videoUrl.startsWith('/api/video-proxy') || videoUrl.startsWith('/')) {
    return videoUrl
  }

  const isCmsVideo =
    videoUrl.includes('cms.optimizely.com') ||
    videoUrl.includes('cmp.optimizely.com') ||
    videoUrl.includes('optimizely.com') ||
    videoUrl.includes('cloudfront.net') ||
    videoUrl.includes('idio.co')

  if (isCmsVideo) {
    const proxiedPath = `/api/video-proxy?url=${encodeURIComponent(videoUrl)}`
    if (typeof window !== 'undefined' && window.location?.origin) {
      return `${window.location.origin}${proxiedPath}`
    }
    return proxiedPath
  }

  return videoUrl
}
